<template>
  <div style="display:inline-block;margin-left: 10px;margin-right:10px">
    <el-button type="primary" size="mini" @click="handleOpen">查看审核记录</el-button>
    <el-dialog :visible.sync="visiable">
      <el-table v-loading="loading" :data="tableData">
        <el-table-column label="操作" width="100" align="center" prop="verifyStatus"></el-table-column>
        <el-table-column label="操作人" width="100" align="center" prop="operatorName"></el-table-column>
        <el-table-column label="操作时间" align="center" prop="operatorTime"></el-table-column>
        <el-table-column label="审核信息" align="center">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.verifyInfo" :key="item">{{index+1}}、{{item}}</div>
          </template>
        </el-table-column>
        <el-table-column label="原因" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.verifyReason.length=== 1 && scope.row.verifyReason[0]=== '-'">-</div>
            <!-- <div v-if="scope.row.verifyReason.length=== 1 && (scope.row.verifyReason[0]=== '-' || scope.row.verifyReason[0]=== '')">-</div> -->
            <div v-else v-for="(item,index) in scope.row.verifyReason" :key="item">{{index+1}}、{{item? item : '-'}}</div>
          </template>
        </el-table-column>
        <el-table-column label="审核类型" width="150" align="center" prop="commitWay"></el-table-column>

      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'audit-dialog',
  props: {
    formData: Object,
    typeKey: String
  },
  data() {
    const config= {
      customer: {
        apiKey: 'customer',
        urlKey: 'getVerifyGroupRecord'
      },
      store: {
        apiKey: 'store',
        urlKey: 'getVerifyStoreRecord'
      }
    }
    return {
      visiable: false,
      tableData: [],
      loading: false,
      setting: config[this.typeKey]
    };
  },
  methods: {
    async handleOpen () {
      this.loading= true
      this.visiable= true
      const {ret, data}= await _api[this.setting.apiKey][this.setting.urlKey](this.formData)
      if(ret===1 && data){
        this.tableData= data
      }
      this.loading= false
    }
  }
};
</script>

<style>
</style>